import { useContext } from 'react';
import { FeedEditorCtx } from '@go-client/context/FeedEdtitorContext';
import { convertContentTemplateToLegacy } from '@go-shared/lib/contentTemplate';

/**
 * Return all the content templates that we have already in the FeedEditorContext
 */
export const useContentTemplates = () => {
  const { contentTemplates } = useContext(FeedEditorCtx);
  return contentTemplates;
};

/**
 * Return all the content templates that we have already in the FeedEditorContext
 * in legacy mode
 */
export const useContentTemplatesLegacy = () => {
  const { contentTemplates, property } = useContext(FeedEditorCtx);
  return contentTemplates.map(ct => convertContentTemplateToLegacy(ct, property!));
};

/**
 * Return all the event templates that we have already in the FeedEditorContext
 */
export const useEventTemplates = () => {
  const { eventTemplates } = useContext(FeedEditorCtx);
  return eventTemplates;
};

/**
 * Return all the event templates that we have already in the FeedEditorContext
 */
export const useEvents = () => {
  const { events } = useContext(FeedEditorCtx);
  return events;
};

export const useVenueTemplates = () => {
  const { venueTemplates } = useContext(FeedEditorCtx);
  return venueTemplates;
};
